<!-- <div class="has-border2">
  
</div> -->
<div class="setting-popup circle-checkbox-settingpopup">
  <p-tabs [value]="'0'">
    <p-tablist>
      <p-tab value="0">Swim-lanes</p-tab>
      <p-tab value="1">Default View</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="listbox">
          <div
            *ngFor="let item of swimLanes; let i = index"
            [attr.id]="'task-' + item.sortOrder"
            pDraggable
            (onDragStart)="dragStart(item, i)"
            (onDrop)="drop(i)"
            pDroppable
            class="d-flex justify-content-between align-items-center globalborder-btm-header pb-2 pt-2">
            <div class="d-flex gap-2 align-items-center">
              <p-checkbox
                [binary]="true"
                [(ngModel)]="item.isActive"
                value="{{ item.isActive }}"
                inputId="name"
                class="label-align"></p-checkbox>
              <label for="name">{{ item.name }}</label>
            </div>
            <i class="pi pi-bars"></i>
          </div>
        </div>
        <div class="col-lg-12 mt-3 d-flex gap-3 justify-content-end">
          <!-- <button
            pButton
            type="button"
            label="Cancel"
            (click)="close()"
            class="p-button-secondary p-button-sm p-button-outlined"></button>
          <button
            pButton
            type="button"
            label="Update"
            class="p-button-sm"
            (click)="updateSwimLanes()"></button> -->

          <p-button
            label="Cancel"
            (click)="close()"
            variant="outlined"
            severity="secondary" />

          <p-button label="Update" (click)="updateSwimLanes()" />
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <div class="listbox">
          <div
            class="d-flex gap-2 align-items-center globalborder-btm-header pb-2 pt-2">
            <p-radioButton
              name="viewType"
              (ngModelChange)="onChangeViewType($event)"
              [(ngModel)]="viewType"
              value="{{ TaskManagerView.Kanban }}"
              label="Kanban"></p-radioButton>

            <label for="ingredient1" class="ml-2">Kanban</label>
          </div>
          <div
            class="d-flex gap-2 align-items-center globalborder-btm-header pb-2 pt-2">
            <p-radioButton
              name="viewType"
              (ngModelChange)="onChangeViewType($event)"
              [(ngModel)]="viewType"
              value="{{ TaskManagerView.List }}"
              label="List"></p-radioButton>

            <label for="ingredient1" class="ml-2">List</label>
          </div>
          <div
            class="d-flex gap-2 align-items-center globalborder-btm-header pb-2 pt-2">
            <p-radioButton
              name="viewType"
              (ngModelChange)="onChangeViewType($event)"
              [(ngModel)]="viewType"
              value="{{ TaskManagerView.Calendar }}"
              label="Calendar"></p-radioButton>

            <label for="ingredient1" class="ml-2">Calendar</label>
          </div>

          <!-- Calendar Duration Options -->
          <div *ngIf="viewType === TaskManagerView.Calendar" class="ms-4 mt-2">
            <div
              class="d-flex gap-2 align-items-center globalborder-btm-header pb-2 pt-2"
              *ngFor="let duration of durationTypes">
              <p-radioButton
                name="durationType"
                [(ngModel)]="selectedDuration"
                [value]="duration"></p-radioButton>
              <label class="ml-2">{{ duration }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-12 mt-3 gap-3 d-flex gap-3 justify-content-end">
          <p-button
            label="Cancel"
            (click)="close()"
            variant="outlined"
            severity="secondary" />

          <p-button label="Update" (click)="updateDefaultView()" />

          <!-- <button
            pButton
            type="button"
            (click)="close()"
            label="Cancel"
            class="p-button-secondary p-button-sm p-button-outlined"></button>
          <button
            pButton
            type="button"
            label="Update"
            class="p-button-sm"
            (click)="updateDefaultView()"></button> -->
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
